import { supabase } from '../supabaseClient';

// ** get future events
async function getAllFutureEvents() {
    const { data, count, error } = await supabase.from('Events')
        .select('*', { count: 'exact' })
        // .or('status.eq.Upcoming', 'status.eq.Live')
        //.eq('status', 'Live')
        .eq('isPublished', true)
        // .eq('userId',loggedInUserId)
        .order('last_updated_at', { ascending: false })

    // ??upcoming events
    // .gt('startDateTime', Date.now())
    if (data) return { data, count };
    else throw error;
}
//get All active events
async function getAllEvents() {
    const { data, count, error } = await supabase.from('Events')
        .select('*', { count: 'exact' })
        // .or('status.eq.Upcoming', 'status.eq.Live')
        //.eq('status', 'Live')
        .eq('isPublished', true)
        // .eq('userId',loggedInUserId)
        .order('last_updated_at', { ascending: false })
        .lte('startDateTime', Date.now())
        .gte('endDateTime', Date.now());
    if (data) return { data, count };
    else throw error;
}

async function getAllEventsForLiveInventory() {
    const { data, count, error } = await supabase.from('Events')
        .select('*', { count: 'exact' })
        // .or('status.eq.Upcoming', 'status.eq.Live')
        //.eq('status', 'Live')
        .eq('isPublished', true)
        // .eq('userId',loggedInUserId)
        .order('last_updated_at', { ascending: false })
    // .lte('startDateTime', Date.now() )
    // .gte('endDateTime', Date.now());
    if (data) return { data, count };
    else throw error;
}


async function getEventToken(eventId, leadId,eventTokenIds) {
    const { data, count, error } = await supabase.from('EventTokens')
        .select('*,prerequisiteId(*,tokenId(*)),tokenId(*,inventoryTypeId!left(*))', { count: 'exact' })
        .order('last_updated_at', { ascending: false })
        .eq('eventId', eventId)
        .in('eventTokenId', eventTokenIds)
        // ! vedashree changes => priority pass
        .eq('tokenId.isPriorityPass', false)
        // .neq('leadId',leadId)
        .lte('startDateTime', Date.now()).gte('endDateTime', Date.now());
    if (data) return { data, count };
    else throw error;
}
//EventTokenLeadRelation
async function assignNewToken(assignTokenData, leadId, tokenNumber) {
    const { data, error } =
        await supabase.from('EventTokenLeadRelations').insert([
            {
                // paymentId: assignTokenData.paymentId,
                eventTokenId: assignTokenData.selectedEventToken.eventTokenId,
                leadId: leadId,
                // projectId: null,//remaining
                eventId: assignTokenData.selectedEventToken.eventId,
                amount: assignTokenData.selectedEventToken.tokenId.amount,
                paidAmount: 0,
                qrUrl: '',
                tokenNumber: tokenNumber,
                NoOfBookingAllow: assignTokenData?.selectedEventToken?.tokenId?.NoOfBookingAllow || 1,
                preferredLocation: assignTokenData?.preferredLocation || null,
                // bandNumber:null,
                // carryForwardCount:0,
                // groupId:null,
            }])
    if (data) return data;
    else throw error;
}
// Case through payment tab assign new token
async function assignNewTokenThroughPaymentTab(obj) {
    const { data, error } =
        await supabase.from('EventTokenLeadRelations').insert([obj])
    if (data) return data;
    else throw error;
}
async function updateLeadStatus(leadId) {
    const { data, error } = await supabase
        .from('LeadStatus')
        .update({ status: 'Token Payment Pending', last_updated_at: Date.now() })
        .eq('leadId', leadId)
    if (data) return data;
    else throw error;
}
//Check For payment done
async function checkPaymentStatus(leadId, paymentId) {
    const { data, error } = await supabase
        .from('TokenTransactions')
        .select('paymentLinkId,status')
        .eq('leadId', leadId)
        .eq('paymentId', paymentId)
    if (data) return data;
    else throw error;
}

//change token modal
async function getSelectedToken(leadId, eventId, isPaymentTab = false) {
    let query = supabase
        .from('EventTokenLeadRelations')
        .select('*,eventTokenId(*,tokenId(*))', { count: 'exact' })
        .eq('leadId', leadId)
        .eq('eventId', eventId)

    if (isPaymentTab) {
        query = query.or('status.eq.adjusted,status.eq.active')
    } else {
        query = query.eq('isPrerequisiteUsed', false).in('status', ['active', 'alloted', 'adjusted'])
    }
    const { data, error, count } = await query
    if (data) return { data, count };
    else throw error;
}

async function getAllotmentPaymentCheck(id) {
    let query = supabase
        .from("AllotmentPayment")
        .select("*", { count: "exact" })
        .eq('status', 'Cancelled')
        .eq('paymentId', id)

    const { data, error, count } = await query
    if (data) return { data, count };
    else throw error;
}
//get all except current one
async function getAllTokens(tokenName, eventId) {
    console.log(tokenName);
    const { data, error } = await supabase
        .from('EventTokens')
        .select('*,prerequisiteId(*,tokenId(*)),tokenId(*,inventoryTypeId!left(*))').eq('eventId', eventId).neq('tokenId.name', tokenName)
        // .eq('tokenId.isPriorityPass', false)
        .lte('startDateTime', Date.now()).gte('endDateTime', Date.now());
    if (data) return data;
    else throw error;
}

//Update  table EventTokenLeadRelation
async function updateEventLeadToken(amount, paidAmount, eventTokenId, eventId, leadId, tokenNumber) {
    const { data, error } =
        await supabase.from('EventTokenLeadRelations')
            .update(
                { amount: amount, paidAmount: paidAmount, eventTokenId: eventTokenId, last_updated_at: Date.now(), tokenNumber: tokenNumber })
            .eq('leadId', leadId).eq('eventId', eventId)
    if (data) return data;
    else throw error;
}
// **Update only specific token
async function updateEventLeadTokenSpecific(amount, paidAmount, eventTokenId, eventId, leadId, tokenNumber, paymentId, status) {
    const { data, error } =
        await supabase.from('EventTokenLeadRelations').update(
            { amount: amount, paidAmount: paidAmount, eventTokenId: eventTokenId, last_updated_at: Date.now(), tokenNumber: tokenNumber, status: status, eventId: eventId, created_at: Date.now(), checkpt1: false, checkpt2: false }).eq('leadId', leadId)
            // , carryForwardCount: 1
            // .eq('eventId', eventId)
            .eq('paymentId', paymentId)
    if (data) return data;
    else throw error;
}
//on sucessfull payment add this query (pending)
async function TokenTransactions(eventTokenId, leadId, amount, modeOfPayment) {
    const { data, error } =
        await supabase.from('EventTokenLeadRelations').insert([
            {
                eventTokenId: eventTokenId,
                leadId: leadId,
                amount: amount,
                modeOfPayment: modeOfPayment,
                dateTime: Date.now()
            }])
    if (data) return data;
    else throw error;
}

async function updateEventLeadTokenGroup(obj, id) {
    const { data, error } =
        await supabase.from('EventTokenLeadRelations').update(obj).eq('paymentId', id)
    if (data) return data;
    else throw error;
}
async function updateTokenTransaction(obj, id) {
    const { data, error } =
        await supabase.from('TokenTransactions').update(obj).eq('paymentId', id)
    if (data) return data;
    else throw error;
}
//getSpecific launch in add site visit modal

async function getSpecificLaunch(eventId, search) {
    let query = supabase.from('Launches').select('* , projectId(*)').eq('eventId', eventId)
    if (search !== null || search !== '' || search !== undefined) {
        query = query.ilike("title", `%${search}%`);
    }

    const { data, error, count } = await query;
    if (data) return { data, count };
    else throw error;
}

//get assigned Tokens from table EventTokenLeadRelation ,check for refundable true? not able to get paymentId that's why join TokenRefundRequests table
async function getAssignedToken(leadId) {
    const { data, error } =
        await supabase.from('EventTokenLeadRelations').select('*,eventId(*),TokenRefundRequests!left(*),eventTokenId(*,tokenId(*,inventoryTypeId(*)))').eq('leadId', leadId).order('last_updated_at', { ascending: false })
    if (data) return data;
    else throw error;
}

async function getAssignedTokenForHolders(leadId, tokenNumber) {
    const { data, error } =
        await supabase.from('EventTokenLeadRelations').select('*,eventId(*),TokenRefundRequests!left(*),eventTokenId(*,tokenId(*,inventoryTypeId(*)))').eq('leadId', leadId).order('last_updated_at', { ascending: false }).eq('tokenNumber', tokenNumber)
    if (data) return data;
    else throw error;
}

async function getEventTokenLeadRelations(eventId) {
    const { data, error } = await supabase.from('EventTokenLeadRelations').select('*,groupId(*),leadId(*,personId(*),fosId(*),cpId(*),userId(*)),eventTokenId(*,tokenId(*))').eq('eventId', eventId)
    if (data) return data;
    else throw error;
}

async function getPreSelectInventory(eventTokenId) {
    const { data, error } = await supabase.from('PreselectInventoryRelations').select('*').eq('eventTokenId', eventTokenId)
    if (data) return data;
    else throw error;
}
async function updateLeadTokenStatus(leadId, status, paymentId) {
    const { data, error } =
        await supabase.from('EventTokenLeadRelations')
            .update({ status: status, last_updated_at: Date.now() })
            .eq('leadId', leadId)
            .eq('paymentId', paymentId);
    if (data) return data;
    else throw error;
}
async function checkForPerquisiteToken(eventTokenId, leadId) {
    const { data, error } = await supabase.from('EventTokenLeadRelations')
        .select('*')
        .eq('eventTokenId', eventTokenId)
        .eq('leadId', leadId)
        .eq('status', 'active')
    if (data) return data;
    else throw error;
}


async function getLinkedTokenDetails(eventId, paymentId, leadId) {
    const { data, error } = await supabase.from('EventTokenLeadRelations')
        .select('*,groupId(*),leadId(*,personId(*),fosId(*),cpId(*),userId(*)),eventTokenId(*,tokenId(*))')
        .eq('eventId', eventId)
        .eq('linkedTokenId', paymentId)
        .eq('leadId', leadId)
        .eq('status', 'active')
    if (data) return data;
    else throw error;
}
// ! vedashree changes
async function updateEventLeadTokenEvent(obj, eventTokenId, leadId) {
    // const { data, error } =
    //     await supabase.from('EventTokenLeadRelations').update(obj).eq('paymentId', paymentId).eq('status', 'active')
    // if (data) return data;
    // else throw error;
    return new Promise(async (resolve, reject) => {
        await supabase.from('EventTokenLeadRelations').select('*').eq('eventTokenId', eventTokenId).eq('leadId', leadId).eq('status', 'active').then(async (resp) => {
            if (resp && resp.data?.length > 0) {
                const paymentId = resp.data[0].paymentId;
                await supabase.from('EventTokenLeadRelations').update(obj).eq('paymentId', paymentId).eq('status', 'active').is('linkedTokenId', null).then((response) => {
                    if (response.data) {
                        resolve(response.data)
                    } else {
                        reject(response.error);
                    }
                }).catch((err) => {
                    reject(err)
                })
            } else {
                reject('Prerequisite token not found');
            }
        }).catch((err) => {
            reject(err)
        })
    })
}
// async function updateEventLeadTokenEvent(obj, eventTokenId) {
//     const { data, error } =
//         await supabase.from('EventTokenLeadRelations').update(obj).eq('eventTokenId', eventTokenId).eq('status','active')
//     if (data) return data;
//     else throw error;
// }
export {
    getAllEvents, getEventToken, assignNewToken, updateLeadStatus,
    getSelectedToken, getAllTokens, updateEventLeadToken, getSpecificLaunch, getAssignedToken, getEventTokenLeadRelations,
    updateEventLeadTokenGroup, checkPaymentStatus,
    getAllFutureEvents, getPreSelectInventory,
    updateLeadTokenStatus, updateEventLeadTokenSpecific, checkForPerquisiteToken, updateTokenTransaction,
    assignNewTokenThroughPaymentTab,
    getLinkedTokenDetails,
    updateEventLeadTokenEvent,
    getAssignedTokenForHolders,
    getAllEventsForLiveInventory,
    getAllotmentPaymentCheck
}